import Spinner from 'react-bootstrap/Spinner';
import { useEffect } from 'react';

const SpinLoader = (props: any) => {
    
const showOverlay = () => {
    let overlay: any = document.querySelector('.overlay-out'); 
    if(!overlay) {
        let div = document.createElement('div');
        div.classList.add('overlay-out')
        document.body.appendChild(div);
    }
    else {
        overlay.style.display = 'block';
    }
}

    useEffect(() => {
        showOverlay();
      }, []);

    return (
        <div className='overlay'>
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
      );
}

export default SpinLoader;